/**
 * The 40px bar at the top of Home's center pane, plus the prev/next arrows
 * that step through the For Review list and the button that reopens the
 * collapsed right rail.
 */
import { ChevronDown, ChevronUp, PanelRightOpen } from "lucide-react";
import type { FC, ReactNode } from "react";

import { HeaderDivider, HeaderIconButton } from "@/components/app-header";
import { cn } from "@/lib/utils";

export const PaneBar: FC<{
  children: ReactNode;
  trailing?: ReactNode;
  className?: string;
}> = ({ children, trailing, className }) => (
  <div
    className={cn(
      "@container flex h-10 min-w-0 shrink-0 items-center gap-2 overflow-hidden border-b border-border py-0 pr-2 pl-4",
      className
    )}
    data-testid="pane-bar"
  >
    {children}
    {trailing}
  </div>
);

export const NavArrows: FC<{
  onPrev: () => void;
  onNext: () => void;
  canPrev: boolean;
  canNext: boolean;
}> = ({ onPrev, onNext, canPrev, canNext }) => (
  <span className="inline-flex gap-1">
    <HeaderIconButton
      label="Previous"
      onClick={onPrev}
      disabled={!canPrev}
      data-testid="triage-prev"
    >
      <ChevronUp className="size-4" />
    </HeaderIconButton>
    <HeaderIconButton
      label="Next"
      onClick={onNext}
      disabled={!canNext}
      data-testid="triage-next"
    >
      <ChevronDown className="size-4" />
    </HeaderIconButton>
  </span>
);

/** Shown at the end of the pane bar while the right rail is collapsed. */
export const RailReopenButton: FC<{ onClick: () => void }> = ({ onClick }) => (
  <>
    <HeaderDivider />
    <HeaderIconButton
      label="Show calendar and activity"
      onClick={onClick}
      data-testid="rail-reopen"
    >
      <PanelRightOpen className="size-4" />
    </HeaderIconButton>
  </>
);
